import {
  SERVICE_PROVIDER_AUTH_LOGIN_URL,
  SP_LOGIN_SOURCE_KEY,
  SP_LOGIN_SOURCE_VALUE,
  routerPath,
} from "../config/constents";

/** True when this browser session entered via SP signup app handoff. */
export const isServiceProviderLoginSession = (): boolean => {
  try {
    return localStorage.getItem(SP_LOGIN_SOURCE_KEY) === SP_LOGIN_SOURCE_VALUE;
  } catch {
    return false;
  }
};

export const markServiceProviderLoginSession = () => {
  localStorage.setItem(SP_LOGIN_SOURCE_KEY, SP_LOGIN_SOURCE_VALUE);
};

/**
 * Clears session and sends the user to the correct login surface.
 * SP sessions return to the signup/agency login app (not platform /).
 */
export const clearSessionAndRedirectToLogin = () => {
  const returnToSpLogin = isServiceProviderLoginSession();
  console.log("returnToSpLogin", returnToSpLogin);
  try {
    localStorage.clear();
  } catch {
    /* ignore */
  }
  if (returnToSpLogin) {
    window.location.href = SERVICE_PROVIDER_AUTH_LOGIN_URL;
    return;
  }
  window.location.href = routerPath.auth.home;
};
